import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import EfUsersStories, { EfUsersStoriesItemProps } from '@elem/ui/ef-users-stories';

export default function TheComp() {
    const listUsers: EfUsersStoriesItemProps[] = [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717761564481/aa2.jpg',
            desc: 'DELTA Pro 3 can run a well pump in an emergency. I am ecstatic that my pressure washer works with the DP3. I absolutely adore the amazing design and game-changing quiet fans.',
            user_icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717223834852/kol_2_avatar.png',
            user_name: 'Luke L., Monticello, IL',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717761564481/aa2.jpg',
            desc: 'DELTA Pro 3 can run a well pump in an emergency. I am ecstatic that my pressure washer works with the DP3. I absolutely adore the amazing design and game-changing quiet fans.',
            user_icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717223834852/kol_2_avatar.png',
            user_name: 'Luke L., Monticello, IL',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717761564481/aa2.jpg',
            desc: 'DELTA Pro 3 can run a well pump in an emergency. I am ecstatic that my pressure washer works with the DP3. I absolutely adore the amazing design and game-changing quiet fans.',
            user_icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717223834852/kol_2_avatar.png',
            user_name: 'Luke L., Monticello, IL',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717761564481/aa2.jpg',
            desc: 'DELTA Pro 3 can run a well pump in an emergency. I am ecstatic that my pressure washer works with the DP3. I absolutely adore the amazing design and game-changing quiet fans.',
            user_icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717223834852/kol_2_avatar.png',
            user_name: 'Luke L., Monticello, IL',
        },
    ];
    return (
        <div id={'UsersStoriesA'}>
            <EfSpec />
            <EfTitle>title</EfTitle>
            <EfUsersStories list={listUsers} />
        </div>
    );
}
